import { useFormik } from "formik";
import React, { useRef, useState } from "react";
import Select from "../form/select/Select";
import PageTitle from "../partials/PageTitle";
import * as Yup from "yup";
import { createPermission } from "../../redux/slice/permission/permissionSlice";
import { useDispatch } from "react-redux";

const modules = [
  { id: 1, name: "Accounting" },
  { id: 2, name: "User" },
  { id: 3, name: "Customer" },
  { id: 4, name: "Office" },
  { id: 5, name: "Staff" },
  { id: 6, name: "Settings" },
  { id: 7, name: "Policy" },
  { id: 8, name: "Report" },
  { id: 9, name: "Workflow" },
  { id: 10, name: "Claim" },
];
const CreatePermission = () => {
  const dispatch = useDispatch();
  const [name, setName] = useState([{ name: "" }]);

  const moduleSelectref = useRef();

  const breadcrumb = {
    from: {
      title: "Settings",
      link: "/admin/create-permission",
    },
    current: {
      title: "Create Permission",
      link: null,
    },
  };

  const addName = () => {
    let obj = {
      name: "",
    };
    setName([...name, obj]);
  };

  const removeName = (index) => {
    if (name?.length > 1) {
      let data = [...name];
      data.splice(index, 1);
      setName(data);
    }
  };

  const handleNameDetails = (e, index) => {
    let data = [...name];
    data[index][e.target.name] = e.target.value;
    setName(data);
  };

  const onSubmit = (values, { resetForm }) => {
    let payload = { ...values, p_name_arrays: [...name] };
    dispatch(createPermission(payload));
    setName([{ name: "" }]);
    resetForm();
    // moduleSelectref?.current?.clearValue()
  };

  const validationScehma = Yup.object().shape({
    p_module: Yup.string("Module must be a string").required(
      "Module cannot be blank"
    ),
    p_sub_module: Yup.string("Sub module must be a string").required(
      "Sub Module cannot be blank"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      p_module: "",
      p_sub_module: "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  const modulesData = modules?.map((module) => {
    return {
      label: module.name,
      value: module.id,
    };
  });

  return (
    <>
      {/* page title */}
      <PageTitle title='Create Permission' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <form onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='row mb-2'>
                  <div className='col-sm-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Select Module <span className='text-danger'>*</span>
                    </label>
                  </div>

                  <div className='col-sm-4'>
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "p_module" } });
                      }}
                      id='p_module'
                      name='p_module'
                      data={modulesData}
                      value={values?.p_module}
                      onChange={(selectedOption) =>
                        setFieldValue("p_module", selectedOption?.value)
                      }
                      ref={moduleSelectref}
                    />
                    {errors?.p_module && touched?.p_module && (
                      <p className='mb-0 text-danger'>
                        {errors?.p_module + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-2'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label htmlFor='staff_id' className='col-form-label'>
                      Sub Module
                      <span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div className='col-sm-4'>
                    <input
                      type='text'
                      name='p_sub_module'
                      id='p_sub_module'
                      className='form-control form-control-sm'
                      value={values?.p_sub_module}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.p_sub_module && touched?.p_sub_module && (
                      <p className='mb-0 text-danger'>
                        {errors?.p_sub_module + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-2'>
                  <div className='col-sm-2 text-right sm-text-end'>
                    <label htmlFor='name' className='col-form-label'>
                      Name
                      <span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div className='col-sm-4'>
                    {name.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className='d-flex gap-1 justify-content-center'
                        >
                          <input
                            type='text'
                            name='name'
                            className='form-control form-control-sm mb-1'
                            value={item?.name}
                            onChange={(e) => handleNameDetails(e, index)}
                            // onBlur={handleBlur}
                          />
                          {name?.length > 1 && (
                            <div
                              className={` d-flex justify-content-end cursor-p ${
                                index === 0 ? "mt-1" : ""
                              }`}
                            >
                              <span
                                className=''
                                onClick={() => removeName(index)}
                              >
                                <i className='mdi mdi-delete text-danger fs-4 '></i>
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className='col-sm-1'>
                    <button
                      type='button'
                      className='btn btn-primary btn-sm px-4 rounded d-flex justify-content-center align-items-center gap-1'
                      onClick={addName}
                    >
                      <i className='mdi mdi-plus'></i>
                      <span>Add</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className='row mb-3'>
                <div className='col-sm-2'></div>
                <div className='col-sm-5 ms-2'>
                  <button
                    type='submit'
                    className='btn btn-primary btn-md px-4 rounded'
                  >
                    <span>Create</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePermission;
